import request from '@/utils/request'

const url = '/home/news/'
const api = {
  Query (data) {
    return request({
      url: url + 'Query',
      method: 'post',
      data
    })
  },
  getDetail (data) {
    return request({
      url: url + 'getDetail',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/news.js